import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class MarcasService {
  BASEURL: string;
  httpHeaders: HttpHeaders;

  constructor(private http: HttpClient) {
    this.BASEURL = environment.apiUrl;

    this.httpHeaders = new HttpHeaders({
      Authorization: localStorage.getItem('tokenMappe'),
    });
  }

  listaMarcas(): Observable<any> {
    return this.http.get(`${this.BASEURL}/brands`, {
      headers: this.httpHeaders,
    });
  }

  listaUsuarios(): Observable<any> {
    return this.http.get(`${this.BASEURL}/users/administrators`, {
      headers: this.httpHeaders,
    });
  }

  listaTaxas(): Observable<any> {
    return this.http.get(`${this.BASEURL}/fees`, {
      headers: this.httpHeaders,
    });
  }

  salvaMarca(body: any): Observable<any> {
    return this.http.post(`${this.BASEURL}/brands`, body, {
      headers: this.httpHeaders,
    });
  }

  excluirMarca(id: string): Observable<any> {
    return this.http.delete(`${this.BASEURL}/brands/${id}`, {
      headers: this.httpHeaders,
    });
  }

  obterDadosMarca(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/brands/${id}`, {
      headers: this.httpHeaders,
    });
  }

  editarMarca(id: string, body: any): Observable<any> {
    return this.http.put(`${this.BASEURL}/brands/${id}`, body, {
      headers: this.httpHeaders,
    });
  }

  uploadImages(image: string): Observable<any> {
    return this.http.post(`${this.BASEURL}/images`, { image }, {
      headers: this.httpHeaders,
    });
  }

  listaCategoriasMarcas(): Observable<any> {
    return this.http.get(`${this.BASEURL}/categories/belonging/brands`, {
      headers: this.httpHeaders,
    });
  }
  
  obterLogradouroCep(cep: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/addresses/cep/${cep}`, {
      headers: this.httpHeaders,
    });
  }
}
